var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7875 7.25688L19.3875 1.16252C19.0219 1.00781 18.4008 0.882812 18.0047 0.882812C17.6063 0.882812 16.9875 1.00781 16.6196 1.16252L2.21955 7.25688C0.8766 7.81979 0 9.1531 0 10.6316C0 30.2209 14.1873 39.8828 17.9965 39.8828C21.8981 39.8828 36 30.1186 36 10.6316C36 9.1531 35.1234 7.81979 33.7875 7.25688ZM18.0065 4.53906C18.0054 4.53845 18.0041 4.53784 18.0028 4.53754L18.0065 4.53906ZM17.9977 36.2278C11.0653 33.293 3.60427 24.0354 3.60427 10.6433C3.60427 10.6395 3.60427 10.6357 3.60427 10.6319L17.9155 4.57151C17.9404 4.56374 17.9842 4.55392 18.0242 4.54653L32.4 10.6316C32.4 26.0559 22.9778 34.119 17.9977 36.2278ZM16.2 12.4609V20.9922C16.2 22.0015 17.0063 22.8203 18 22.8203C18.9937 22.8203 19.8 22.0015 19.8 20.9922V12.4609C19.8 11.4517 18.9937 10.6328 18 10.6328C17.0063 10.6328 16.2 11.4517 16.2 12.4609ZM18 25.2578C16.6744 25.2578 15.6 26.3492 15.6 27.6953C15.6 29.0414 16.6744 30.1328 18 30.1328C19.3256 30.1328 20.4 29.0414 20.4 27.6953C20.4 26.3492 19.3256 25.2578 18 25.2578Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8.88281,
    width: 7,
    height: 22,
    fill: "#7D9199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustIcon);
export default __webpack_public_path__ + "static/media/trust-icon.8ef4cf723627c79fd92d1ea7cb7be94e.svg";
export { ForwardRef as ReactComponent };